import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Typography from "@mui/material/Typography";
import { Grid } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { FormControl, FormLabel } from "@mui/material";

import { callPacketData } from "../../datastore/emslistSlice";
import Autocomplete from "@mui/material/Autocomplete";
import DenseTable from "./dense-table";

const EMSReport = () => {
  const { catList, emsName, packetData } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [_to, setTo] = useState("");
  const [_from, setFrom] = useState("");
  const [_category, setCategory] = useState("");
  const [error, setError] = useState("");
  const handleToChange = (event) => {
    let _to = event.target.value;
    setTo(_to);
  };
  const handleFromChange = (event) => {
    let _fromDate = event.target.value;
    setFrom(_fromDate);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!_to || !_from || !_category) {
      setError("Select all Fields");
    }

    console.log("error", error);
    if (_to && _from && _category) {
      console.log({
        emsName: emsName,
        start: _to,
        end: _from,
        category: _category,
      });
      let data = {
        emsName: emsName,
        start: _to,
        end: _from,
        category: _category,
      };
      dispatch(callPacketData(data));
    }
  };

  return (
    <Grid container direction="row" spacing={3}>
      <Grid container direction="row" spacing={3}>
        <Grid item xs={8}>
          <form onSubmit={handleSubmit}>
            {error && (
              <Alert style={{ marginBottom: 10 }} severity="error">
                {error}
              </Alert>
            )}
            <Grid
              style={{ marginTop: 10 }}
              container
              direction="column"
              spacing={3}
            >
              <Grid style={{marginLeft:1}}alignContent="flex-start" container spacing={4}>
                <Grid alignContent="flex-start" item xs={4}>
                  <FormLabel>From:</FormLabel>
                  <TextField type="datetime-local" onChange={handleToChange} />
                </Grid>
                <Grid alignContent="flex-start" item xs={4}>
                  <FormLabel>To:</FormLabel>
                  <TextField
                    type="datetime-local"
                    onChange={handleFromChange}
                  />
                </Grid>
              </Grid>
              <Grid
                alignContent="flex-start"
                item
                xs={5}
                container
                direction="row"
                spacing={1}
              >
                <Grid item>
                  <Autocomplete
                    disablePortaloption
                    id="combo-box-demo"
                    options={catList}
                    sx={{ width: 300 }}
                    onChange={(event, value) => setCategory(value)}
                    renderInput={(params) => (
                      <TextField {...params} label="Data Category" />
                    )}
                  />
                </Grid>
                <Grid container spacing={2} direction="row">
                  <Grid item>
                    <Button type="submit">Download</Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EMSReport;
